jQuery(function($){

	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
    investmentsNav();
    siteMenu();

    function activateTabByHash(hash) {
      if (!hash) return;
  
      const $targetTab = $('.investments__type#' + hash);
      const $targetNav = $('.investments__nav a[href="#' + hash + '"]');
  
      if ($targetTab.length && $targetNav.length) {
        // Deaktywuj wszystkie
        $('.investments__type').removeClass('active');
        $('.investments__nav a').removeClass('active');
  
        // Aktywuj odpowiednie
        $targetTab.addClass('active');
        $targetNav.addClass('active');
  
        // Przewiń do sekcji .investments
        const $section = $('.investments');
        if ($section.length) {
          $('html, body').animate({
            scrollTop: $section.offset().top
          }, 500);
        }
      }
    }
  
    // 1. Aktywuj tab po załadowaniu strony (na podstawie hash)
    const hash = window.location.hash.replace('#', '');
    activateTabByHash(hash);
  
    // 2. Obsługa kliknięcia w zakładki
    $('.investments__nav a').on('click', function(e) {
      e.preventDefault();
      const hash = $(this).attr('href').replace('#', '');
  
      activateTabByHash(hash);
  
      // Zaktualizuj hash w URL
      window.history.pushState(null, null, '#' + hash);
    });

    function investmentsNav() {
        $(".investments__nav a").click(function(event) {
            event.preventDefault();
            var href = $(this).attr('href');
            $(".investments__nav a").removeClass('active');
            $(this).addClass('active');
            $(".investments__type").hide();
            $(".investments__type"+href).show()
        });
        
    }

    function siteMenu() {
		var window_width = jQuery(window).width();
		
		jQuery(".page-id-2 .inline a, .page-id-2 .site-header__logo, .page-id-2 .site-footer__logo").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
          console.log(href);
		  var pos = 120;
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  
		});
		
  
		jQuery(".page-id-3953 .site-header__logo, .page-id-3953 .site-footer__logo, .page-id-3953 .inside-en a").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
		  var pos = 70;
		  var href = href.replace("en/", "");
		
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  if (window_width < 768) {
		  jQuery('#hamburger').removeClass('open');
		  jQuery('.site-header__navigation ul').slideUp(400);
		  }
		});
	  }

    if (window.location.hash) {
		console.log('hash');
        const targetId = window.location.hash; // Pobierz hash (np. #section1)
        const $target = $(targetId); // Znajdź element o podanym ID

        if ($target.length) {
            // Jeśli element istnieje, przewiń do niego z offsetem -200px
            $('html, body').animate({
                scrollTop: $target.offset().top + 100
            }, 500); // Animacja przewijania trwa 500ms
        }
    }

    $(function(){
        loopcounter('myCountdown');
    });

	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -86;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1024) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
			});
			
			$('.menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
				}
			});

            $('.site-header__navigation a').on('click', function(event) {
				$('.site-header__navigation > ul').slideUp(500);
			    $('.site-header').removeClass('menu-opened');
                $('#hamburger').removeClass('open');
			});
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.5 44C47.5 45.933 45.933 47.5 44 47.5L2 47.5C1.17157 47.5 0.5 46.8284 0.5 46L0.500004 2C0.500004 1.17157 1.17158 0.499996 2 0.499996L44 0.5C45.933 0.5 47.5 2.06701 47.5 4L47.5 44Z" stroke="white"/><path d="M28.666 24L19.3327 24" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.666L19.3333 23.9993L24 19.3327" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H46C46.8284 0.5 47.5 1.17157 47.5 2V46C47.5 46.8284 46.8284 47.5 46 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z" stroke="white"/><path d="M19.334 24H28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.334L28.6667 24.0007L24 28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
			autoplayHoverPause:true
		});

        jQuery('.partners-slider').owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            items:1,
            autoplay:false,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            
            navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 44C48 46.2091 46.2091 48 44 48L2 48C0.895432 48 7.8281e-08 47.1046 1.74846e-07 46L4.02145e-06 2C4.11801e-06 0.895427 0.895436 -4.11801e-06 2 -4.02145e-06L44 -3.49691e-07C46.2091 -1.56562e-07 48 1.79086 48 4L48 44Z" fill="#F6F6FB"/><path d="M28.666 24L19.3327 24" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.667L19.3333 24.0003L24 19.3337" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4C0 1.79086 1.79086 0 4 0H46C47.1046 0 48 0.895431 48 2V46C48 47.1046 47.1046 48 46 48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#F6F6FB"/><path d="M19.334 24H28.6673" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.333L28.6667 23.9997L24 28.6663" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                stagePadding: 30,
                },
                766:{
                items:2,
                stagePadding: 30,
                },
                1022:{
                items:3,
                stagePadding: 30,
                },
                1240:{
                items:4,
                stagePadding: 120,
                }
                
            }
        });

		var sync1 = jQuery(".gallery");
    var sync2 = jQuery(".gallery-thumbs");
    var slidesPerPage = 5; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1
      .owlCarousel({
      items: 1,
      slideSpeed: 3000,
      nav: true,
      autoplayHoverPause: true,
      autoplaySpeed: 1400, 
      dots: false,
      loop: false,
	  navText: ['aaaaa','bbbbb'],
	  responsiveClass: true,
      responsive: {
        0: {
          item: 1,
        },
        600: {
          items: 1,
        }
      },
      responsiveRefreshRate: 200,
      navText: [
        '',
        ''
      ]
    })
      .on("changed.owl.carousel", syncPosition);

    sync2
      .on("initialized.owl.carousel", function() {
      sync2
        .find(".owl-item")
        .eq(0)
        .addClass("current");
    })
      .owlCarousel({
      items: slidesPerPage,
	  margin: 32,
      dots: true,
      nav: false,
      smartSpeed: 1000,
      slideSpeed: 1000,
      slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
      responsiveRefreshRate: 100,
	  responsive: {
        0: {
          item: 2,
          autoplay: false
        },
        600: {
          items: 4,
          autoplay: false
        },

		1200: {
			items: 5,
			autoplay: false
		  },

		  1500: {
			items: 6,
			autoplay: false
		  }
      },
    })
      .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
      //if you set loop to false, you have to restore this next line
      //var current = el.item.index;

      //if you disable loop you have to comment this block
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }

      //end block

      sync2
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
      var onscreen = sync2.find(".owl-item.active").length - 1;
      var start = sync2
      .find(".owl-item.active")
      .first()
      .index();
      var end = sync2
      .find(".owl-item.active")
      .last()
      .index();

      if (current > end) {
        sync2.data("owl.carousel").to(current, 100, true);
      }
      if (current < start) {
        sync2.data("owl.carousel").to(current - onscreen, 100, true);
      }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        sync1.data("owl.carousel").to(number, 100, true);
      }
    }

    sync2.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = jQuery(this).index();
      sync1.data("owl.carousel").to(number, 300, true);
    });
}

})